export const STREAMING_TYPE = {
    hls: "hls",
    dash: "dash",
  };